import React, { useEffect, useMemo, useState } from 'react'
import { Box, Grid } from '@mui/material'
import { gecinaBlueMain, gecinaBrownMain, WHITE } from '../../theme'
import { useNavigate } from 'react-router-dom'
import liens from '../../enum/liens'
import { ListeProceduresResponseModel } from '../../modules/listeProcedures/types/filtresListeProceduresModel'
import { filtresListeProceduresResponseEnum, statutListeProceduresEnum } from '../../modules/listeProcedures/enums/listeProceduresEnum'
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import ButtonWithIcon from '../button/ButtonWithIcon'
import { cancelProcedure, getMetadata, relanceManuelle } from './api/procedureArianeApi'
import SvgCycle from '../../icons/SvgCycle'
import PopinReactivation from './components/PopinReactivation'

interface AcceptingProps {
	procedure: ListeProceduresResponseModel
}

type VueProcedureArianeProps = AcceptingProps

const VueProcedureAriane: React.FC<VueProcedureArianeProps> = (
	{
		procedure
	}) => {
	const navigate = useNavigate()
	const [dateRelance, setDateRelance] = useState<Date>()
	const [procedureCanceled, setProcedureCanceled] = useState<boolean>()
	const [tempsAvantRelance, setTempsAvantRelance] = useState<number>(1440)
	const formatDateToLocalString = (date?: string) => !!date ? new Date(date).toLocaleDateString() : '-'
	const [popinOuverte, setPopinOuverte] = useState<boolean>(false)

	const isExpired = useMemo(() => {
		return procedure?.[filtresListeProceduresResponseEnum.status] === statutListeProceduresEnum.expired
	}, [procedure])

	const procedureEnCours = useMemo(() => {
		return procedure?.[filtresListeProceduresResponseEnum.status] === statutListeProceduresEnum.ongoing || procedure?.[filtresListeProceduresResponseEnum.status] === statutListeProceduresEnum.approval
	}, [procedure?.[filtresListeProceduresResponseEnum.status]])

	useEffect(() => {
		getMetadata(procedure[filtresListeProceduresResponseEnum.id])
			.then((response) => {
				if (response.date_relance) {
					setDateRelance(new Date(response.date_relance))
				}
				if (response.relance_timer) {
					setTempsAvantRelance(response.relance_timer)
				}

			})
	}, [])

	const getDiffMinutes = (dateA: Date, dateB: Date) => {
		let diff = (dateB.getTime() - dateA.getTime()) / 1000
		diff = diff / 60
		return Math.abs(Math.round(diff))
	}

	return (
		<Box sx={{ background: gecinaBlueMain, minHeight: '192px', paddingX: '172px', zIndex: 100 }}>
			<Box onClick={() => navigate(liens.listeProcedure, { state: { rafraichir: true } })}
			     sx={{
				     width: 'fit-content',
				     fontFamily: 'Montserrat',
				     fontSize: 16,
				     color: gecinaBrownMain,
				     display: 'flex',
				     flexDirection: 'row',
				     paddingTop: '21px',
				     '&:hover': { cursor: 'pointer' }
			     }}>
				<img src="/img/back_arrow.png" height={20} alt="Back arrow" />
				<Box sx={{ marginLeft: '10px' }}>Retour à la liste</Box>
			</Box>
			<Box sx={{ paddingTop: '22px', fontFamily: 'BlackerDisplay', fontSize: 28, fontWeight: 900 }}>
				{procedure[filtresListeProceduresResponseEnum.name] || ''}
			</Box>
			<Grid container sx={{ fontFamily: 'Montserrat', paddingTop: '40px', paddingBottom: '19px' }} gap="10px 40px">
				<Grid container item xs flexDirection="column">
					<Box sx={{ fontSize: 12 }}>Statut</Box>
					<Box sx={{ fontWeight: 600 }}>{procedure[filtresListeProceduresResponseEnum.status] || ''}</Box>
				</Grid>
				<Grid container item xs flexDirection="column">
					<Box sx={{ fontSize: 12 }}>Date de création</Box>
					<Box sx={{ fontWeight: 600 }}>{formatDateToLocalString(procedure[filtresListeProceduresResponseEnum.date_creation])}</Box>
				</Grid>
				<Grid container item xs flexDirection="column">
					<Box sx={{ fontSize: 12 }}>Date d'expiration</Box>
					<Box sx={{ fontWeight: 600 }}>{formatDateToLocalString(procedure[filtresListeProceduresResponseEnum.date_expiration])}</Box>
				</Grid>
				{procedureEnCours && (
					<>
						<Grid container item xs minWidth="150px" justifyContent="flex-end">
							<ButtonWithIcon
								bgcolor={WHITE}
								color={gecinaBlueMain}
								onClick={() => {
									relanceManuelle(procedure[filtresListeProceduresResponseEnum.id])
										.then(() => setDateRelance(new Date()))
								}}
								startIcon={<ForwardToInboxIcon />}
								sx={{
									fontFamily: 'Montserrat',
									fontSize: 12,
									fontWeight: 600
								}}
								disabled={!!dateRelance && (getDiffMinutes(new Date(), dateRelance) < tempsAvantRelance)}
							>
								Envoyer une relance
							</ButtonWithIcon>
						</Grid>
						<Grid container item xs minWidth="150px">
							<ButtonWithIcon
								bgcolor={WHITE}
								color={gecinaBlueMain}
								onClick={() => {
									cancelProcedure(procedure[filtresListeProceduresResponseEnum.id])
										.then(() => {
											setProcedureCanceled(true)
											procedure[filtresListeProceduresResponseEnum.status] = statutListeProceduresEnum.canceled
										})
								}}
								startIcon={<CancelOutlinedIcon />}
								sx={{
									fontFamily: 'Montserrat',
									fontSize: 12,
									fontWeight: 600
								}}
								disabled={!!procedureCanceled}
							>
								Annuler la procédure
							</ButtonWithIcon>
						</Grid>
					</>
				)}
				{isExpired && (
					<Grid container item xs minWidth="150px">
						<ButtonWithIcon
							bgcolor={WHITE}
							color={gecinaBlueMain}
							onClick={() => setPopinOuverte(true)}
							startIcon={<SvgCycle color={gecinaBlueMain} />}
							sx={{
								fontFamily: 'Montserrat',
								fontSize: 12,
								fontWeight: 600
							}}
						>
							Réactiver la procédure
						</ButtonWithIcon>
					</Grid>
				)}
			</Grid>
			<PopinReactivation onCloseDialog={() => setPopinOuverte(false)} open={popinOuverte} procedure={procedure} />
		</Box>
	)
}

export default VueProcedureAriane
